<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <zt-tab>
      <zt-tab-item
      @click.native="resetPagination()"

        :label="$t('message.LicensesHistoryComponent.tabs.licenses.tabName_mine')"
      >
        <component
          :is="mobileHistory"
          :history="historyLicenses"
          :totalItems="totalItems"
          :showTitle="showTitle"
          :loading="firstLoading"
          @get-history="getHistoryLicenses"
        />
      </zt-tab-item>
      <zt-tab-item
      @click.native="resetPagination()"
        v-if="hasVPI"
        :label="
          $t('message.LicensesHistoryComponent.tabs.otherRequests.tabName')
        "
      >
        <component
          :is="mobileSpecialRequests"
          :history="specialRequests"
          :totalItems="totalItemsSpecialRequests"
          :showTitle="showTitle"
          :loading="firstLoading"
          @get-history="getSpecialRequests"
        />
      </zt-tab-item>
    </zt-tab>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import HistoryList from './HistoryList'
import HistoryTable from './HistoryTable'
import SpecialRequestsList from './SpecialRequestsList.vue'
import SpecialRequestsTable from './SpecialRequestsTable.vue'
import { mapGetters } from 'vuex'
import { useWindowResize } from '@sichern/ui-elements'
import _ from 'lodash'

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      licenses: Licenses,
      firstLoading: false,
      loading: false,
      historyLicenses: [],
      specialRequests: [],
      totalItems: 0,
      totalItemsSpecialRequests: 0,
      perPageHistory: 8,
      pageHistory: 1,
      totalSpecialItems: 0,
      perPageSpecialRequests: 8,
      pageSpecialRequests: 1
    }
  },
  created() {
    this.firstLoading = true
    this.licenses = new Licenses()
    this.getHistoryLicenses()
    this.getSpecialRequests()
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    },
    mobileHistory() {
      return this.windowResize.width < 1024 ? HistoryList : HistoryTable
    },
    mobileSpecialRequests() {
      return this.windowResize.width < 1024
        ? SpecialRequestsList
        : SpecialRequestsTable
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    }
  },
  methods: {
    resetPagination() {
      this.pageHistory = 1
      this.perPageHistory = 8
      this.pageSpecialRequests = 1
      this.perPageSpecialRequests = 8
      this.historyLicenses = []
      this.specialRequests = []
    },
    getHistoryLicenses(event) {


      this.loading = true
      this.licenses
        .getHistoryLicenses(this.perPageHistory, this.pageHistory)
        .then(response => {

          let responseLicenses = response.data.results.data
          this.totalItems = response.data.pagination.total
          if (responseLicenses.length > 0) {
            this.pageHistory++
            responseLicenses.forEach(element => {
              this.historyLicenses.push(element)
            })
            if (event) {
              event.loaded()
            }
          } else {
            if (event) {
              event.complete()
            }
          }
        })
        .then(() => {
          this.firstLoading = false
          this.loading = false
        })
        .catch(error => {
          this.firstLoading = false
          this.loading = false
          this.$swal({
            type: 'error',
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: 'Aceptar'
          })
        })
    },
    getSpecialRequests(event) {
      
      this.loading = true
      this.licenses
        .getSpecialRequests(this.perPageSpecialRequests, this.pageSpecialRequests)
        .then(response => {
      

          let responseSpecialRequests = response.data.results.data
          this.totalSpecialItems = response.data.pagination.total
          if (responseSpecialRequests.length > 0) {
            this.pageSpecialRequests++
            responseSpecialRequests.forEach(element => {
              this.specialRequests.push(element)
            })
            if (event) {
              event.loaded()
            }
          } else {
            if (event) {
              event.complete()
            }
          }
        })
        .then(() => {
          this.firstLoading = false
          this.loading = false
        })
        .catch(error => {
          this.firstLoading = false
          this.loading = false
          this.$swal({
            type: 'error',
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: 'Aceptar'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-mode {
  ::v-deep .zt-tab-item--active {
    background-color: #2694fc !important;
    border-bottom-color: #2694fc !important;
  }
  
  ::v-deep .zt-tab-item {
    &:hover {
      background-color: rgba(38, 148, 252, 0.1) !important;
    }
  }
  
  /* Override para .child-active button - selector más específico */
  ::v-deep .zt-tab .child-active button.zt-tab--btn,
  ::v-deep .child-active button.zt-tab--btn {
    background-color: #2694fc !important;
    color: #fff !important;
    border-color: #2694fc !important;
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>
